import { render, staticRenderFns } from "./Emblem.vue?vue&type=template&id=a7b7fc74"
import script from "./Emblem.vue?vue&type=script&lang=ts"
export * from "./Emblem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports